import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer, { updateUserData } from "./userSlice";
import fpAppV4Reducer from "./fpAppV4Slice";
import fileViewerReducer from "./fileViewerSlice";
import { readInitialUserDataFromCache } from "@/hooks/useCurrentUser";

/**
 * The app's root reducer. Exported for the story harness, which rebuilds the
 * page's one store from its initial state between stories
 * (test-utils/harness/singletonStore.ts) and so needs the same slices.
 */
export const rootReducer = combineReducers({
  userData: userReducer,
  fileViewerData: fileViewerReducer,
  fpAppV4Data: fpAppV4Reducer,
});

const store = configureStore({
  reducer: rootReducer,
  // Off everywhere: the Redux debugger is retired (#11422), and Redux
  // Toolkit's default would hand the store to the browser extension.
  devTools: false,
});

// Hydrate userData synchronously from localStorage so downstream selectors
// (useOrgId, useWorkspaces, org-scoped bootstraps) read real values on the
// very first render — no waiting on fp0052. useCurrentUser() refreshes in
// the background and re-dispatches updateUserData when fresh data lands.
const cachedUserData = readInitialUserDataFromCache();
if (cachedUserData) {
  store.dispatch(updateUserData(cachedUserData));
}

export default store;

export type RootState = ReturnType<typeof store.getState>;
